import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuthContext } from './AuthContext';
import { API } from '../utils/api';

const ModuleContext = createContext(null);

export function useModules() {
  return useContext(ModuleContext);
}

export function ModuleProvider({ children }) {
  const auth = useAuthContext();
  const [modules, setModules] = useState([]);
  const [moduleDetails, setModuleDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchModules = useCallback(async () => {
    if (!auth?.user || !auth?.headers?.Authorization) {
      setLoading(false);
      return;
    }
    
    try {
      const res = await axios.get(`${API}/modules/my-modules`, {
        headers: auth.headers
      });
      setModules(res.data.modules || []);
      setModuleDetails(res.data.details || []);
    } catch (e) {
      console.error('Failed to fetch modules', e);
      setModules([]);
      setModuleDetails([]);
    } finally {
      setLoading(false);
    }
  }, [auth?.user, auth?.headers]);

  useEffect(() => {
    if (auth?.user && auth?.headers?.Authorization) {
      fetchModules();
    } else {
      setLoading(false);
    }
  }, [auth?.user, auth?.headers, fetchModules]);

  const hasModule = useCallback((moduleCode) => {
    return modules.includes(moduleCode);
  }, [modules]);

  const getModuleInfo = useCallback((moduleCode) => {
    return moduleDetails.find(m => m.code === moduleCode);
  }, [moduleDetails]);

  const refreshModules = useCallback(() => {
    return fetchModules();
  }, [fetchModules]);

  const value = {
    modules,
    moduleDetails,
    hasModule,
    getModuleInfo,
    loading,
    refreshModules
  };

  return (
    <ModuleContext.Provider value={value}>
      {children}
    </ModuleContext.Provider>
  );
}
